import React, { FC, useCallback, useEffect, useState } from 'react';
import { Button, Divider, Input, Select, SelectProps, Space } from 'antd';
import { useBusinessContext } from '../../context/BusinessContext';
import { PlusOutlined } from '@ant-design/icons';
import VendorEditModal, { useVendorEditModal } from './VendorEditModal';
import { useEventListener } from '../../common/EventContext';
import { Vendor } from '../../dto/Vendor';

type Props = Omit<SelectProps<number>, 'options'>;

export const VendorSelect: FC<Props> = (props) => {
  const { getSelectValuesAsync } = useBusinessContext();
  const [loading, setLoading] = useState<boolean>(true);
  const [options, setOptions] = useState<any>([]);
  const [searchText, setSearchText] = useState<string>();
  const modal = useVendorEditModal();
  useEffect(() => {
    getSelectValuesAsync('vendors')
      .then(setOptions)
      .finally(() => setLoading(false));
  }, [getSelectValuesAsync]);

  useEventListener(
    'VENDOR',
    useCallback(
      (dt) => {
        const item: Vendor = dt.data;
        if (dt.action === 'CREATE') {
          props.onChange?.(item.vendorId, {
            label: item.name,
            value: item.vendorId,
          });
        }
      },
      [props],
    ),
  );

  return (
    <>
      <Select
        {...props}
        loading={loading || props.loading}
        options={options}
        showSearch={true}
        optionFilterProp="label"
        allowClear={true}
        onSearch={setSearchText}
        dropdownRender={(menu) => (
          <>
            {menu}
            <Divider style={{ margin: '8px 0' }} />
            <div className="flex flex-col gap-1">
              <Button
                type="link"
                icon={<PlusOutlined />}
                onClick={() => {
                  modal.current?.open(searchText);
                }}
                className="w-full"
              >
                Create Vendor
                {searchText && searchText !== '' && <b>{` "${searchText}"`}</b>}
              </Button>
            </div>
          </>
        )}
      />
      <VendorEditModal ref={modal} />
    </>
  );
};
